import axios from "axios";
import { getToken, getTokenHeader } from "../../../Common/Token";
import { createPaymentUrl, updatePaymentUrl, getPaymentHistoryUrl } from "../urls";


export const createPaymentAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        createPaymentUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updatePaymentAction = async (txnid) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .patch(`${updatePaymentUrl()}`, txnid, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPaymentHistoryAction = (config) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getPaymentHistoryUrl()}?${config.toString()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};